<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="インターネット・セキュリティアプライアンス契約変更"
  >
    <template v-slot:body="{ cancel }">
      <cross-validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-4">
            <div class="modal-body">
              <!-- 基本情報 -->
              <v-card variant="outlined" class="mx-4 mb-4">
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="6">
                        <app-label-group
                          label="回線番号(メイン)"
                          :value="`${selectedItem.enumberMainAct}/${selectedItem.enumberMainSby}`"
                        ></app-label-group>
                      </v-col>
                      <v-col cols="6">
                        <app-label-group
                          label="回線番号(BCP)"
                          :value="`${selectedItem.enumberBcpAct}/${selectedItem.enumberBcpSby}`"
                        ></app-label-group>
                      </v-col>
                      <v-col cols="6">
                        <app-label-group
                          label="VPNコード"
                          :value="selectedItem.vpnCode"
                        ></app-label-group>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
              <!-- セキュリティアプライアンス契約変更 -->
              <v-card variant="outlined" class="main-card mx-4 mb-4">
                <v-card-title class="py-0 screen-title px-2 ma-4">
                  セキュリティアプライアンス契約変更
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col v-if="selectedItem.applianceType === 'UTM'">
                        <div class="mb-3">UTM(1Gbpsベストエフォート)</div>
                      </v-col>
                      <v-col v-if="selectedItem.applianceType === 'IFW'">
                        <div class="d-flex align-center mb-3">
                          <div>インターネットFW(帯域確保型)</div>
                          <div class="ml-6 mw-15">
                            <app-select
                              v-model="form.bandwidth!.value"
                              :items="bandwidth"
                              item-title="text"
                              item-value="value"
                              hide-details
                            />
                          </div>
                          <div class="ml-2">Mbps</div>
                        </div>
                      </v-col>
                    </v-row>
                    <v-row v-if="user.contractSummary.isSecuritySetting">
                      <v-col>
                        <app-label-group
                          label="セキュリティ監視オプション"
                          :value="
                            $filter.enumTo(
                              selectedItem.isSecurityOption,
                              'on_off'
                            )
                          "
                        ></app-label-group>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
              <!-- インターネット契約変更 -->
              <v-card variant="outlined" class="main-card mx-4 mb-4">
                <v-card-title class="py-0 screen-title px-2 ma-4">
                  インターネット契約変更
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <app-label-group label="インターネット帯域">
                          <template #value>
                            <span class="ml-3">
                              <template
                                v-if="selectedItem.applianceType === 'UTM'"
                              >
                                1Gbpsベストエフォート
                              </template>
                              <template
                                v-if="selectedItem.applianceType === 'IFW'"
                              >
                                帯域確保型
                                <template v-if="form.bandwidth!.value > 0">
                                  {{ form.bandwidth!.value }}Mbps
                                </template>
                              </template>
                            </span>
                          </template>
                        </app-label-group>
                      </v-col>
                      <v-col cols="12">
                        <app-label-group label="グローバルIP">
                          <template #value>
                            <div class="pl-3">
                              現在 {{ paidGlobalIpCount }}個 / 上限 32個
                              <br />
                              追加グローバルIP数 :
                              {{ form.numberOfAddGlobalIpAddress }} 個 <br />
                              <app-label-group
                                class="mt-2"
                                label="グローバルIP"
                              >
                                <template #value>
                                  <template
                                    v-for="(
                                      item, index
                                    ) in form.globalIpAddressList"
                                    :key="index"
                                  >
                                    <div class="pl-3 v-row align-center mt-0">
                                      <div class="v-col-6 py-2">
                                        {{ item.globalIpAddress }}
                                        <span v-if="item.isInitialAddress">
                                          (デフォルト)</span
                                        >
                                      </div>
                                      <div class="v-col-2 py-2">
                                        <v-btn
                                          v-if="!item.isInitialAddress"
                                          icon="$mdiMinus"
                                          size="small"
                                          variant="outlined"
                                          class="rounded-sm"
                                          @click="
                                            removeGlobalIpAddress(
                                              item.globalIpAddressSeq
                                            )
                                          "
                                        >
                                        </v-btn>
                                      </div>
                                    </div>
                                  </template>
                                  <div
                                    v-for="i in form.numberOfAddGlobalIpAddress"
                                    class="v-row pl-3 align-center mt-0"
                                    :key="i"
                                  >
                                    <div class="v-col-6 py-2">
                                      設定完了後にIPが払い出されます
                                    </div>
                                    <div class="v-col-2 py-2">
                                      <v-btn
                                        v-if="canRemove"
                                        icon="$mdiMinus"
                                        size="small"
                                        variant="outlined"
                                        class="rounded-sm"
                                        @click="
                                          form.numberOfAddGlobalIpAddress!--
                                        "
                                      >
                                      </v-btn>
                                    </div>
                                  </div>
                                </template>
                              </app-label-group>
                              <div class="v-row pl-3">
                                <div class="v-col-6 py-2"></div>
                                <div class="v-col-2 py-2">
                                  <v-btn
                                    size="small"
                                    icon="$mdiPlus"
                                    class="rounded-sm"
                                    variant="outlined"
                                    :disabled="!canAdd"
                                    @click="form.numberOfAddGlobalIpAddress!++"
                                  >
                                  </v-btn>
                                </div>
                              </div>
                            </div>
                          </template>
                        </app-label-group>
                      </v-col>
                      <v-col cols="12">
                        <app-label-group
                          label="状態"
                          :value="$filter.enumTo(selectedItem.status, 'status')"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
            <cross-validation-provider
              :passed="objectChanged"
              vid="no_change"
              class="mt-4"
            >
              {{ $filter.message("no_change_data") }}
            </cross-validation-provider>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" color="primary" variant="flat">変更</v-btn>
                <v-btn color="primary" variant="outlined" @click="cancel"
                  >キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </cross-validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type {
  Type1Service,
  Bandwidth,
  GlobalIpAddress,
  ContractChangeType1PutRequest,
} from "@/apis/ContractChangeType1Api";
import InternetType1ContractConfirm from "@/modals/applianceContractSetting/type1/contract/InternetType1ContractConfirm.vue";
import cloneDeep from "lodash/cloneDeep";
import { VueFinalModal } from "vue-final-modal";
import AppLabelGroup from "@/components/AppLabelGroup.vue";

type typeContractChangeType1PutRequest = ContractChangeType1PutRequest & {
  globalIpAddressList?: GlobalIpAddress[];
};

export default defineComponent({
  name: "InternetType1ContractModify",
  components: { AppLabelGroup },
  props: {
    selectedItem: {
      type: Object as PropType<Type1Service>,
      required: true,
    },
  },
  data() {
    return {
      user: this.$store.state.user,
      /** 関連項目チェック
       * インターネットFWの帯域確保における帯域値が（数値+単位）が適切な範囲であること
       * 選択形式なので範囲外の値の設定は不可。
       */
      bandwidth: [
        { value: 10, text: " 10 " },
        { value: 20, text: " 20 " },
        { value: 30, text: " 30 " },
        { value: 40, text: " 40 " },
        { value: 50, text: " 50 " },
        { value: 60, text: " 60 " },
        { value: 70, text: " 70 " },
        { value: 80, text: " 80 " },
        { value: 90, text: " 90 " },
        { value: 100, text: " 100 " },
        { value: 200, text: " 200 " },
        { value: 300, text: " 300 " },
        { value: 400, text: " 400 " },
        { value: 500, text: " 500 " },
        { value: 600, text: " 600 " },
        { value: 700, text: " 700 " },
        { value: 800, text: " 800 " },
        { value: 900, text: " 900 " },
        { value: 1000, text: " 1000 " },
      ],
      form: {
        numberOfAddGlobalIpAddress: (this.selectedItem.globalIpAddressList
          .length === 0
          ? 1
          : 0) as number | null,
        deleteGlobalIpAddressSeqList: null as string[] | null,
        note: null,
        contractType1KeyId: "",
        bandwidth: {} as Bandwidth | null,
        globalIpAddressList: [] as GlobalIpAddress[],
      },
      paidGlobalIpCount: this.selectedItem.globalIpAddressList.length,
      cloneItem: {},
    };
  },
  computed: {
    /** true: 削除可能, false: 削除不可 */
    canRemove(): boolean {
      return (
        this.form.globalIpAddressList.length +
          this.form.numberOfAddGlobalIpAddress! >
        1
      );
    },
    /** true: 追加可能, false: 追加不可 */
    canAdd(): boolean {
      return (
        this.paidGlobalIpCount + this.form.numberOfAddGlobalIpAddress! < 32
      );
    },
    /** 関連項目チェック
     * 初期表示した内容から設定内容に変更があること。
     */
    objectChanged(): boolean {
      return this.$crossValidation.objectChanged(this.cloneItem, this.form);
    },
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      /** bandwidth.unitがGBPSの場合は「Mbps」に変換 */
      if (this.selectedItem.bandwidth) {
        this.form.bandwidth = { ...this.selectedItem.bandwidth };
        if (this.form.bandwidth.unit === "GBPS") {
          this.form.bandwidth.value = 1000;
          this.form.bandwidth.unit = "MBPS";
        }
      }
      this.form.contractType1KeyId = this.selectedItem.contractType1KeyId;
      this.form.globalIpAddressList = this.selectedItem.globalIpAddressList.map(
        (e) => ({ ...e })
      );
      this.cloneItem = cloneDeep(this.form);
    },
    /** 確認モーダルの表示 */
    async submit() {
      await this.$modal.show(InternetType1ContractConfirm, {
        selectedItem: this.selectedItem,
        putItem: this.form,
        globalIpAddressList: this.form.globalIpAddressList,
      });
      /** ここでnull設定を行う */
      if (this.selectedItem.applianceType === "UTM") {
        this.form.bandwidth = null;
      }
      this.form.note = this.form.note || null;
      if (this.form.numberOfAddGlobalIpAddress === 0) {
        this.form.numberOfAddGlobalIpAddress = null;
      }
      // 不要な項目の削除(objectChangeでエラーとなるので値を詰め替えてから削除)
      const postForm: typeContractChangeType1PutRequest = cloneDeep(this.form);
      delete postForm.globalIpAddressList;
      await this.$api.contract_change_type1.putType1Service(postForm);
      (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
    },
    /** 登録済のグローバルIPを削除する
     @param globalIpAddressSeq 登録済のIPアドレスID
     */
    removeGlobalIpAddress(globalIpAddressSeq: string) {
      if (!this.form.deleteGlobalIpAddressSeqList) {
        this.form.deleteGlobalIpAddressSeqList = [];
      }
      this.form.deleteGlobalIpAddressSeqList.push(globalIpAddressSeq);
      const index = this.form.globalIpAddressList.findIndex(
        (e) => e.globalIpAddressSeq === globalIpAddressSeq
      );
      this.form.globalIpAddressList.splice(index, 1);
    },
  },
});
</script>

<style lang="scss" scoped>
:deep(.v-card.v-card--variant-outlined) {
  border-color: rgba(0, 0, 0, 0.125) !important;
}
.mw-15 {
  min-width: 15% !important;
}
</style>
